import React from "react";

const AudioDeviceSelector = ({ disabled }) => {
  return (
    <div className="rounded-lg border border-slate-200 p-3">
      <div className="text-sm font-semibold text-slate-700">Audio Device</div>
      <div className="mt-2 text-xs text-slate-500">
        Browser media device selector can be extended here.
      </div>
      <button
        type="button"
        className="mt-2 rounded border border-slate-300 px-3 py-2 text-xs text-slate-700 disabled:opacity-50"
        disabled={disabled}
      >
        Use system default
      </button>
    </div>
  );
};

export default AudioDeviceSelector;
